import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import {TradeEntity} from '../Entities/TradeEntity.js'
import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'

/**
 * @implements UseCase
 */
export class InitTradeTransactionsUseCase extends UseCase {
  #httpTransactionsRepository

  constructor({httpTransactionsRepository}) {
    super()
    this.#httpTransactionsRepository = httpTransactionsRepository
  }

  static create({config}) {
    return new InitTradeTransactionsUseCase({
      httpTransactionsRepository: HTTPTransactionRepository.create({config})
    })
  }

  @inlineError
  async execute({tradeId}) {
    const tradeEntity = TradeEntity.create({id: tradeId})

    const [error] = await this.#httpTransactionsRepository.initTrade({tradeEntity})

    if (error) throw error
  }
}

export const factory = InitTradeTransactionsUseCase.create
